import { ActionIcon, Flex, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ROUTES } from '@/configs/routes';

import s from './NewsHeader.module.scss';

type NewsHeaderProps = {
  title?: string | null;
  backTo?: string;
};

const NewsHeader: React.FC<NewsHeaderProps> = ({ title, backTo }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const handleBack = React.useCallback(() => {
    const fallbackPath = ROUTES.organization.news.create(id ?? '');

    navigate(backTo ?? fallbackPath, { replace: true });
  }, [backTo, id, navigate]);

  return (
    <Flex justify="space-between" align="center" className={s.root}>
      <ActionIcon className={s.root__back} c="dark" variant="transparent" size="lg" onClick={handleBack}>
        <IconArrowLeft size={24} />
      </ActionIcon>
      <Text size="xs" fw={400} c="dimmed" className={s['root__text']}>
        {title}
      </Text>
    </Flex>
  );
};

export default React.memo(NewsHeader);
